import React from 'react';

/**
 * HeroFX — dimming tint + drifting aurora glow in the division color
 * (via the --fx-glow CSS variable set on the page wrapper).
 * Render inside `.landing-hero-cover`, directly after the hero image.
 */
const HeroFX = () => (
    <div className="hero-fx" aria-hidden="true">
        <span className="hero-fx__tint"></span>
        <span className="hero-fx__blob hero-fx__blob--a"></span>
        <span className="hero-fx__blob hero-fx__blob--b"></span>
    </div>
);

export default HeroFX;
